"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _book = require("../../routes/book");
var _connectedReactRouter = require("connected-react-router");
var _reactTransitionGroup = require("react-transition-group");
var _classnames2 = _interopRequireDefault(require("classnames"));
var _actions = require("../../../modalDispatcher/store/actions");
var _Button = _interopRequireWildcard(require("../../ui/Button"));
var _Modal = _interopRequireDefault(require("../../Modal"));
var _Loader = _interopRequireDefault(require("../../ui/Loader"));
var _CompactCardView = _interopRequireDefault(require("../../CompactCardView"));
var _Alert = _interopRequireWildcard(require("../../ui/Alert"));
var _selectors = require("../../Baskets/store/selectors");
var _actions2 = require("../../../bus/ui/actions");
var _BasketItem = require("./components/BasketItem");
var _ActiveBasket = require("./components/ActiveBasket");
var _constants = require("./store/constants");
var _selectors2 = require("./store/selectors");
var _actions3 = require("./store/actions");
var _prev = _interopRequireDefault(require("./img/prev.svg"));
var _next = _interopRequireDefault(require("./img/next.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SaveOfferToBasketModal = function SaveOfferToBasketModal(_ref) {
  var offerID = _ref.offerID,
    onClose = _ref.onClose,
    onCreateBasketWithOffer = _ref.onCreateBasketWithOffer,
    onAddOfferToBasket = _ref.onAddOfferToBasket,
    onRemoveOfferFromBasket = _ref.onRemoveOfferFromBasket,
    onSetBasket = _ref.onSetBasket;
  var _useTranslation = (0, _reactI18next.useTranslation)('SAVE_OFFER_TO_BASKET_MODAL'),
    t = _useTranslation.t;
  var bootstrapUI = (0, _reactRedux.useSelector)(_selectors2.getBootstrapUI);
  var getActiveBasketUI = (0, _reactRedux.useSelector)(_selectors2.getActiveBasketUi);
  var baskets = (0, _reactRedux.useSelector)(_selectors2.getBasketsSimplifiedByActivePage);
  var activeEditingBasketID = (0, _reactRedux.useSelector)(_selectors2.getActiveEditingBasketID);
  var page = (0, _reactRedux.useSelector)(_selectors2.getPage);
  var isDisabledNextButton = (0, _reactRedux.useSelector)(_selectors2.getIsDisabledNextButton);
  var activeBasketID = (0, _reactRedux.useSelector)(_selectors2.getActiveBasketID);
  var activeBasket = (0, _reactRedux.useSelector)(getActiveBasketUI.completed ? function (state) {
    return (0, _selectors.getBasketById)(state, {
      basketID: activeBasketID
    });
  } : R.always(null));
  var dispatch = (0, _reactRedux.useDispatch)();
  var openBasketPage = (0, _react.useCallback)(function (basketID) {
    onClose(null);
    dispatch((0, _actions.globalReset)());
    dispatch((0, _connectedReactRouter.push)("".concat(_book.book.carts, "?id=").concat(basketID)));
  }, [dispatch, onClose]);
  var onPageChange = function onPageChange(newPage) {
    dispatch((0, _actions3.changePage)(newPage, offerID ? undefined : _constants.COUNT_BASKETS_SIMPLIFIED_WITHOUT_OFFER));
  };
  var handleCloseModal = (0, _react.useCallback)(function () {
    return onClose(null);
  }, [onClose]);
  var onNextPage = function onNextPage() {
    return onPageChange(page + 1);
  };
  var onPrevPage = function onPrevPage() {
    return onPageChange(page - 1);
  };
  var onCloseActiveBasket = (0, _react.useCallback)(function () {
    dispatch((0, _actions3.disappearActiveBasket)());
  }, [dispatch]);
  var onExited = (0, _react.useCallback)(function () {
    dispatch((0, _actions3.setActiveBasketID)(null));
    dispatch((0, _actions2.unRegister)(_constants.GET_ACTIVE_BASKET_UI));
  }, [dispatch]);
  var onSuccessDeleting = (0, _react.useCallback)(function () {
    return new Promise(function (resolve) {
      dispatch((0, _actions3.disappearActiveBasket)());
      setTimeout(resolve, Number(_styles.default.animationTime));
    });
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    return function () {
      dispatch((0, _actions3.resetStore)());
      dispatch((0, _actions2.unRegister)(_constants.GET_ACTIVE_BASKET_UI));
    };
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    centered: true,
    closeIcon: true,
    className: (0, _classnames2.default)(_styles.default.modal, _defineProperty({}, _styles.default.activeBasket, activeBasket)),
    size: _Button.SIZES.LARGE,
    onClose: handleCloseModal
  }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, {
    unmountOnExit: true,
    in: Boolean(getActiveBasketUI.animating)
    // timeout={Number(styles.animationTime)}
    ,
    timeout: 0,
    onExited: onExited
  }, function () {
    return /*#__PURE__*/_react.default.createElement(_ActiveBasket.ActiveBasket, {
      basketID: activeBasketID,
      date: activeBasket === null || activeBasket === void 0 ? void 0 : activeBasket.date,
      title: activeBasket === null || activeBasket === void 0 ? void 0 : activeBasket.title,
      offersIDs: activeBasket === null || activeBasket === void 0 ? void 0 : activeBasket.offersIDs,
      showPriceWithMargin: activeBasket === null || activeBasket === void 0 ? void 0 : activeBasket.showPriceWithMargin,
      discount: activeBasket === null || activeBasket === void 0 ? void 0 : activeBasket.discount,
      margin: activeBasket === null || activeBasket === void 0 ? void 0 : activeBasket.margin,
      basketURL: activeBasket === null || activeBasket === void 0 ? void 0 : activeBasket.shortUrl,
      claim: activeBasket === null || activeBasket === void 0 ? void 0 : activeBasket.claim,
      onOpen: handleCloseModal,
      onClose: onCloseActiveBasket,
      onSuccessDeleted: onSuccessDeleting
    });
  }), !activeBasket && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, null, t(offerID ? 'TITLE' : 'TITLE_WITH_DISABLED_ADDING_OFFER')), /*#__PURE__*/_react.default.createElement(_Modal.default.Content, null, bootstrapUI.loading && /*#__PURE__*/_react.default.createElement(_Loader.default, null), bootstrapUI.completed && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.cartsPopupList
  }, onCreateBasketWithOffer && /*#__PURE__*/_react.default.createElement(_CompactCardView.default, {
    onClick: onCreateBasketWithOffer
  }, /*#__PURE__*/_react.default.createElement(_CompactCardView.default.Image, null), /*#__PURE__*/_react.default.createElement(_CompactCardView.default.Body, {
    title: t('CREATE_BASKET_BUTTON')
  })), !onCreateBasketWithOffer && R.isEmpty(baskets) && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    withHTML: true,
    type: _Alert.TYPES.DANGER
  }, t('EMPTY_STATE_OF_BASKETS')), R.map(function (_ref2) {
    var basketID = _ref2.id;
    return /*#__PURE__*/_react.default.createElement(_BasketItem.BasketItem, {
      key: basketID,
      basketID: basketID,
      offerID: offerID,
      isEditing: activeEditingBasketID === basketID,
      isActive: activeBasketID === basketID,
      onAdd: onAddOfferToBasket,
      onActive: onSetBasket,
      onRemove: onRemoveOfferFromBasket,
      onOpen: openBasketPage
    });
  }, baskets)), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.footer
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    onClick: function onClick() {
      return onClose();
    },
    to: _book.book.carts
  }, t('BASKETS_PAGE_LINK')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.controls
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    theme: _Button.THEMES.TRANSPARENT,
    disabled: page === 1,
    icon: _prev.default,
    onClick: onPrevPage
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    theme: _Button.THEMES.TRANSPARENT,
    disabled: isDisabledNextButton,
    icon: _next.default,
    onClick: onNextPage
  })))), bootstrapUI.error && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    type: _Alert.TYPES.ERROR
  }, bootstrapUI.error))));
};
SaveOfferToBasketModal.propTypes = {
  offerID: _propTypes.default.string,
  onAddOfferToBasket: _propTypes.default.func,
  onCreateBasketWithOffer: _propTypes.default.func,
  onSetBasket: _propTypes.default.func,
  onRemoveOfferFromBasket: _propTypes.default.func,
  onClose: _propTypes.default.func
};
var _default = exports.default = (0, _react.memo)(SaveOfferToBasketModal);